import i18next from 'i18next'

import { PersistService } from 'src/data/common/PersistService'
import addresses_en from 'src/translation/en/addresses.json'
import balance_en from 'src/translation/en/balance.json'
import common_en from 'src/translation/en/common.json'
import missing_pd_en from 'src/translation/en/missing-pd.json'
import missing_rx_en from 'src/translation/en/missing-rx.json'
import orders_en from 'src/translation/en/orders.json'
import payment_en from 'src/translation/en/payment.json'
import pd_en from 'src/translation/en/pd.json'
import profile_en from 'src/translation/en/profile.json'
import rma_en from 'src/translation/en/rma.json'
import rx_en from 'src/translation/en/rx.json'
import addresses_fr from 'src/translation/fr/addresses.json'
import balance_fr from 'src/translation/fr/balance.json'
import common_fr from 'src/translation/fr/common.json'
import missing_pd_fr from 'src/translation/fr/missing-pd.json'
import missing_rx_fr from 'src/translation/fr/missing-rx.json'
import orders_fr from 'src/translation/fr/orders.json'
import payment_fr from 'src/translation/fr/payment.json'
import pd_fr from 'src/translation/fr/pd.json'
import profile_fr from 'src/translation/fr/profile.json'
import rma_fr from 'src/translation/fr/rma.json'
import rx_fr from 'src/translation/fr/rx.json'

export default function configureTrans(
  Basei18next: typeof i18next,
  lang = (PersistService.fetch('language', 'local') as string) ?? 'en'
): void {
  Basei18next.init({
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    lng: lang,
    resources: {
      fr: {
        common: common_fr,
        profile: profile_fr,
        addresses: addresses_fr,
        rx: rx_fr,
        pd: pd_fr,
        orders: orders_fr,
        missing_rx: missing_rx_fr,
        missing_pd: missing_pd_fr,
        balance: balance_fr,
        payment: payment_fr,
        rma: rma_fr,
      },
      en: {
        common: common_en,
        profile: profile_en,
        addresses: addresses_en,
        rx: rx_en,
        pd: pd_en,
        orders: orders_en,
        missing_rx: missing_rx_en,
        missing_pd: missing_pd_en,
        balance: balance_en,
        payment: payment_en,
        rma: rma_en,
      },
    },
  })
}
